import { useEditorStore } from '@/stores/editor-store';

interface ColorPaletteProps {
  readonly onOpenBrowser: () => void;
}

export function ColorPalette({ onOpenBrowser }: ColorPaletteProps) {
  const palette = useEditorStore((s) => s.palette);
  const activeColorIndex = useEditorStore((s) => s.activeColorIndex);
  const setActiveColorIndex = useEditorStore((s) => s.setActiveColorIndex);

  return (
    <div className="flex items-center gap-2">
      {/* Palette swatches */}
      <div className="flex items-center gap-1.5 overflow-x-auto">
        {palette.length === 0 && (
          <span className="text-xs text-gray-400">Brak kolorów — dodaj z przeglądarki</span>
        )}
        {palette.map((color) => {
          const isActive = activeColorIndex === color.index;
          return (
            <button
              key={color.index}
              onClick={() => setActiveColorIndex(color.index)}
              className={`relative flex h-9 w-9 shrink-0 items-center justify-center rounded-md border-2 transition-all ${
                isActive
                  ? 'border-primary-600 ring-2 ring-primary-200'
                  : 'border-gray-300 hover:border-gray-400'
              }`}
              style={{ backgroundColor: color.beadHex }}
              title={`${color.label}: ${color.beadCode} ${color.beadHex}`}
            >
              <span
                className="text-[10px] font-bold"
                style={{
                  color: isLightColor(color.beadHex) ? '#333' : '#fff',
                }}
              >
                {color.label}
              </span>
            </button>
          );
        })}
      </div>

      {/* Add color button */}
      <button
        onClick={onOpenBrowser}
        className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md border-2 border-dashed border-gray-300 text-gray-400 hover:border-primary-400 hover:text-primary-500"
        title="Dodaj kolor z przeglądarki koralików"
      >
        +
      </button>
    </div>
  );
}

function isLightColor(hex: string): boolean {
  const clean = hex.replace('#', '');
  const r = parseInt(clean.substring(0, 2), 16);
  const g = parseInt(clean.substring(2, 4), 16);
  const b = parseInt(clean.substring(4, 6), 16);
  return (r * 299 + g * 587 + b * 114) / 1000 > 150;
}
